import { AxiosError } from "axios";

export interface ApiError {
  message: string;
  status?: number;
  data?: unknown;
  isApiError: true;
}

export function toApiError(e: unknown): ApiError {
  if (typeof e === "string") {
    return {
      message: e,
      isApiError: true,
    };
  }

  if (e instanceof AxiosError) {
    return {
      message: e.response?.data?.message || e.message || "Network error",
      status: e.response?.status,
      data: e.response?.data,
      isApiError: true,
    };
  }

  if (e instanceof Error) {
    return {
      message: e.message,
      isApiError: true,
    };
  }

  if (e && typeof e === "object" && "message" in e) {
    const error = e as { message: unknown; status?: unknown; data?: unknown };
    return {
      message:
        typeof error.message === "string" ? error.message : "Unknown error",
      status: typeof error.status === "number" ? error.status : undefined,
      data: error.data,
      isApiError: true,
    };
  }

  return {
    message: "Unknown error",
    isApiError: true,
  };
}

export function getProblemDetailsMessage(e: unknown): string {
  if (e instanceof AxiosError) {
    const data: unknown = e.response?.data;
    if (
      data &&
      typeof data === "object" &&
      "detail" in data &&
      typeof data.detail === "string" &&
      data.detail
    ) {
      return data.detail;
    }
  }
  return toApiError(e).message;
}

export type ApiRejectPayload = {
  status?: number;
  message: string;
};

export function createApiRejectPayload(error: unknown): ApiRejectPayload {
  const apiError = toApiError(error);
  return {
    status: apiError.status,
    message: apiError.message,
  };
}

export function isUnauthorizedPayload(payload: unknown): boolean {
  return (
    typeof payload === "object" &&
    payload !== null &&
    "status" in payload &&
    (payload as ApiRejectPayload).status === 401
  );
}

export function isOrderNotFoundPayload(payload: unknown): boolean {
  const status =
    typeof payload === "object" &&
    payload !== null &&
    "status" in payload &&
    (payload as ApiRejectPayload).status;

  return status === 400 || status === 404;
}
